import { ErrorObject } from '@msc-b2c/interfaces/interfaces';
import { Warning } from '../../../../interfaces/src/lib/interfaces/apiInterfaces/CompleteProfileResponse';
import { SpecificErrorMessage, WarningProps } from '@msc-b2c/interfaces/types';

export const getErrorContent = (
  apiErrorResponse: ErrorObject,
  errorConfig: SpecificErrorMessage | undefined
) => {
  const errorCode = apiErrorResponse.issue_code;

  // Try to find a matching specific error
  const matchedError = errorConfig?.specificErrorMessageList?.find(
    (item) => item.errorCodeConfiguration === errorCode
  );

  if (matchedError) {
    return {
      title: matchedError.errorTitleConfiguration,
      message: matchedError.errorMessageConfiguration,
    };
  }

  // Fallback to generic error
  return {
    title: errorConfig?.genericErrorTitle ?? '',
    message: errorConfig?.genericErrorMessage ?? '',
  };
};

/**
 * Retrieves warning details based on error codes from a given array of warnings.
 *
 * @param warningsArray - An array of `Warning` objects containing warning codes.
 * @param warningsProps - A `SpecificErrorMessage` object containing configuration for specific and generic warnings.
 * @returns An array of `WarningProps` objects, each containing the icon, text, and description for a warning.
 */
export const retrieveWarningByErrorCode = (
  warningsArray: Warning[],
  warningsProps: SpecificErrorMessage
): WarningProps[] => {
  return (
    warningsArray?.map((warning: Warning) => {
      const matchedWarning = warningsProps?.specificErrorMessageList?.find(
        (item) => item.errorCodeConfiguration === warning.code
      );

      return {
        icon: warningsProps.errorMessageIcon,
        text: matchedWarning?.errorTitleConfiguration ?? warningsProps.genericErrorTitle,
        description: matchedWarning?.errorMessageConfiguration ?? warningsProps.genericErrorMessage,
      };
    }) || []
  );
};
